import { FormFieldErrors } from '../../../types/error.types.ts';
import { OnboardingFormFields } from '@Types/index.ts';
export const getFormFieldsModel = () => {
  const formList = Object.values(OnboardingFormFields);
  return formList.reduce((acc, key) => ({ ...acc, [key]: '' }), {}) as FormFieldErrors;
};
